export default class ExcelController {

    static fileName(): string {
        const url = Office.context.document.url;
        const fileName = url?.split("/").pop();
        const lastPart = fileName?.split("\\").pop();
        return lastPart ?? "";
    }
    
    static async saveAsBlob(): Promise<Blob | null> {
        return new Promise((resolve, reject) => {
            Office.context.document.getFileAsync(
                Office.FileType.Compressed,
                { sliceSize: 65536 },
                (result) => {
                    if (result.status !== Office.AsyncResultStatus.Succeeded) {
                        reject(result.error);
                        return;
                    }

                    const file = result.value;
                    const sliceCount = file.sliceCount;
                    const slices: Uint8Array[] = new Array(sliceCount);

                    let currentSlice = 0;

                    const getNextSlice = () => {
                        file.getSliceAsync(currentSlice, (sliceResult) => {
                            if (sliceResult.status !== Office.AsyncResultStatus.Succeeded) {
                                file.closeAsync();
                                reject(sliceResult.error);
                                return;
                            }

                            // Store raw byte data for this slice
                            slices[currentSlice] = new Uint8Array(sliceResult.value.data);
                            currentSlice++;

                            if (currentSlice < sliceCount) {
                                getNextSlice();
                            } else {
                                file.closeAsync();

                                // Combine all slices into a single Blob
                                const blob = new Blob(slices as BlobPart[], {
                                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                });

                                resolve(blob);
                            }
                        });
                    };

                    getNextSlice();
                }
            );
        });
    }
}